// Hook produktów proponowanych dla oferty – GET /sales-crm/clients/:id/offers/:offerId/suggested-products

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmSuggestedProduct {
  productId: number;
  productName: string | null;
  symbol: string | null;
  category: string | null;
  imageUrl: string | null;
  priceNet: number | null;
  priceGross: number | null;
  stockQty: number;
  frequency: number;
  source: 'orders' | 'history';
}

export interface ISalesCrmSuggestedProductsResponse {
  items: ISalesCrmSuggestedProduct[];
}

const getSalesCrmOfferSuggestedProducts = (
  clientId: number,
  offerId: string
): Promise<ISalesCrmSuggestedProductsResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/offers/${offerId}/suggested-products`);

export const useGetSalesCrmOfferSuggestedProducts = (
  clientId: number,
  offerId: string,
  options?: UseQueryOptions<ISalesCrmSuggestedProductsResponse, IError>
) =>
  useQuery<ISalesCrmSuggestedProductsResponse, IError>(
    ['sales-crm', 'client', clientId, 'offer', offerId, 'suggested-products'],
    () => getSalesCrmOfferSuggestedProducts(clientId, offerId),
    {
      ...options,
      enabled:
        options?.enabled !== false && clientId > 0 && String(offerId).trim().length > 0
    }
  );
